import { createContext, useContext } from 'react';

import type {
  WebChromeLegacyActionName,
  WebProductEventName,
} from '@cfa/pathway-fe-shared';

export type ProductTrack = (
  productEvent: WebProductEventName,
  properties?: Record<string, unknown>,
) => boolean;

export type ChromeTrack = (
  action: WebChromeLegacyActionName,
  properties?: Record<string, unknown>,
) => boolean;

export interface AmplitudeTrackingContextValue {
  track: ProductTrack;
  trackChrome: ChromeTrack;
}

export const AmplitudeContext =
  createContext<AmplitudeTrackingContextValue | null>(null);

const noopProductTrack: ProductTrack = () => false;

const noopChromeTrack: ChromeTrack = () => false;

export const useAmplitudeTrack = (): ProductTrack => {
  const context = useContext(AmplitudeContext);
  return context?.track ?? noopProductTrack;
};

export const useAmplitudeTrackChrome = (): ChromeTrack => {
  const context = useContext(AmplitudeContext);
  return context?.trackChrome ?? noopChromeTrack;
};

/** @deprecated Use {@link ProductTrack} via {@link useAmplitudeTrack}. */
export type Track = ProductTrack;
